import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getTransactionList(contractId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${contractId}/transactions/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params: { pageSize: -1 } });
      const { items } = processSuccessResponse(res);

      return items;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async retractTransaction(contractId, transactionId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${contractId}/transactions/${transactionId}:retract/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, {});
      const { items } = processSuccessResponse(res);

      return items;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },
};
